import styled from 'styled-components';

export const TooltipBoxTableContainer = styled.div`
  display: flex;
  padding: 25px;
  background-color: white;
  border-radius: 5px;
  -webkit-box-shadow:
    0px 10px 13px -7px #000000,
    5px 5px 0px 5px rgba(255, 255, 255, 0);
  box-shadow:
    0px 10px 13px -7px #000000,
    5px 5px 0px 5px rgba(255, 255, 255, 0);
`;

export const TootipTable = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

  th {
    color: #9399b2;
    font: normal normal bold 16px Biotif;
  }

  th,
  td {
    font: normal normal bold 16px Biotif;
    text-align: left;
    padding: 16px;
  }

  tr:nth-child(even) {
    border-radius: 5px;
    background-color: #f3f4f8;
  }
`;

export const CellSpan = styled.span`
  color: #4948ac;

  &:hover {
    cursor: pointer;

    color: #2dcaff;
  }
`;
